/**
 * Created by andrey on 01.08.2022
 */

HideAnimations = function (f) {
    const sceneComponent = ComponentMap.get(this.node, DifferencesSceneComponent);

    if (Game.currentGame.outcome === GameBase.OUTCOME_VICTORY) {
        sceneComponent.photos.complete();
    } else if (Game.currentGame.discoverBooster) {
        Game.currentGame.discoverBooster.stopHint();
    }

    this.node.runAction(new cc.Sequence(
        new cc.DelayTime(1),
        new cc.CallFunc(() => {
            this.playersView.hide();
            sceneComponent.photos.hide();
        }),
        new cc.DelayTime(1),
        new cc.CallFunc(f)
    ));
};
